<template>
    <span
        class="ro-status-tag"
        :style="{
            color: meta.color,
            backgroundColor: meta.bg,
            borderColor: meta.color ? `${meta.color}40` : 'transparent',
        }"
    >
        <span class="ro-status-dot" :style="{ backgroundColor: meta.color }"></span>
        <span class="ro-status-text">{{ label }}</span>
    </span>
</template>

<script>
import { ORDER_STATUS_META } from "@/core/config/recruitmentOrders/recruitmentOrdersOption";

export default {
    name: "OrderStatusTag",
    props: {
        status: { type: [String, Number], default: 1 },
        statusLabel: { type: String, default: "" },
    },
    computed: {
        meta() {
            return ORDER_STATUS_META[this.status] || { label: this.statusLabel || "Chờ duyệt", type: "info", color: "#64748b", bg: "#f1f5f9" };
        },
        label() {
            return this.statusLabel || this.meta.label || `Trạng thái ${this.status}`;
        },
    },
};
</script>

<style scoped>
.ro-status-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    border: 1px solid transparent;
    white-space: nowrap;
    line-height: 1.2;
}
.ro-status-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    flex-shrink: 0;
}
.ro-status-text {
    white-space: nowrap;
}
</style>
